import React, {Component} from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import SprzedazMiesiecznychSearchbox from "./components/SprzedazMiesiecznychSearchbox";
import RaportyService from "../RaportyService";
import TrasowyMiesiecznyChart from "./components/TrasowyMiesiecznyChart";
import initialData from "../../../utilities/initialData/initialData";
import DlaJednejTrasyMiesiecznyChart from "./components/DlaJednejTrasyMiesiecznyChart";
import DateAndTimeFormat from "../../../utilities/DateAndTimeFormat";
import moment from "moment";

export default class SprzedazMiesiecznychContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: null,
            daneTrasowyZnizki: [],
            daneTrasowyGeneral: [],
            daneDlaTrasyZnizki: [],
            daneDlaTrasyGeneral: [],
            daneDlaTrasySzczegoly: [],
        };
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    }

    componentDidMount() {
        let params = {
            "idTr": null,
            "nazTr": null,
            "dataOd": DateAndTimeFormat.formatYYYYMMDD(moment()),
            "dataDo": DateAndTimeFormat.formatYYYYMMDD(moment()),
            "statBil": null,
            "statusNazwa": null,
            "sprzedazMiejsce": null
        }
        this.onClickSzukaj(params)
    }

    onClickSzukaj(params) {
        RaportyService.pobierzRaportBiletowMiesiecznychNew(params).then(function (response) {
            this.setState({params: params})

            if (Boolean(params.idTr)) {
                // dla jednej trasy
                this.setState({
                    daneDlaTrasyZnizki: response.data[0],
                    daneDlaTrasyGeneral: response.data[1],
                    daneDlaTrasySzczegoly: response.data[2],
                })
            } else {
                // trasowy
                this.setState({
                    daneTrasowyZnizki: response.data[0],
                    daneTrasowyGeneral: response.data[1],
                })
            }
        }.bind(this))
    }

    renderNaglowek(params) {

        let naglowek = 'Sprzedaż dla wszystkich tras'
        if (Boolean(params.idTr)) {
            naglowek = 'Sprzedaż dla trasy ' + params.nazTr
        }

        naglowek = naglowek + ' w okresie ' + params.dataOd + ' - ' + params.dataDo


        if (Boolean(params.statusNazwa)) {
            naglowek = naglowek + ' ze statusem ' + params.statusNazwa
        }

        if (Boolean(params.sprzedazMiejsce)) {
            naglowek = naglowek + ' w miejscu ' + params.sprzedazMiejsce
        }

        return naglowek
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                              history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RaportyContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb
                                    links={[{addressUrl: '/raporty', text: 'Raporty'}, {
                                        addressUrl: '/raporty/sprzedaz-miesiecznych',
                                        text: 'Sprzedaż biletów miesięcznych'
                                    }]}/>
                                <SubHeader currentLink={this.props.match.path}
                                           obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <SprzedazMiesiecznychSearchbox handleClickSzukaj={this.onClickSzukaj}/>
                        </Col>
                        <Col xs={12}>
                            {
                                Boolean(this.state.params) ?
                                    Boolean(this.state.params.idTr) ?
                                        <div>
                                            <Col xs={12}>
                                                <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                            </Col>
                                            <DlaJednejTrasyMiesiecznyChart
                                                daneDlaTrasyZnizki={this.state.daneDlaTrasyZnizki}
                                                daneDlaTrasyGeneral={this.state.daneDlaTrasyGeneral}
                                                daneDlaTrasySzczegoly={this.state.daneDlaTrasySzczegoly}
                                                colorArray={initialData.returnColorArray()}
                                            />
                                        </div>
                                        :
                                        <div>
                                            <Col xs={12}>
                                                <h2 style={{textAlign: 'center'}}>{this.renderNaglowek(this.state.params)}</h2>
                                            </Col>
                                            <TrasowyMiesiecznyChart
                                                daneTrasowyZnizki={this.state.daneTrasowyZnizki}
                                                daneTrasowyGeneral={this.state.daneTrasowyGeneral}
                                                colorArray={initialData.returnColorArray()}
                                            />
                                        </div>
                                    :
                                    ''
                            }
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/SprzedazMiesiecznych/SprzedazMiesiecznychContainer.js